module.exports = __webpack_public_path__ + "static/assets/3378c716ed8f6cfdf8e2fd79278640d8.png";